import React from "react";
import { IFormSubmit } from "../../../interfaces/common/IFormSubmit";

export default function FormSubmit({children}: IFormSubmit)
{
    return (
        <div className="form-submit">
            {children}
        </div>
    );
}